import { BADGES_COLOR_TYPES } from 'components/Shared/Badge';

export const CLAIM_UPLOAD_STATUS = {
  COMPLETED: 'Completed',
  COMPLETED_WITH_ERRORS: 'CompletedWithErrors',
  REJECTED: 'Rejected',
  VALIDATION_FAILED: 'ValidationFailed',
};

const STATUS_COLOR = {
  [CLAIM_UPLOAD_STATUS.COMPLETED]: BADGES_COLOR_TYPES.green,
  [CLAIM_UPLOAD_STATUS.COMPLETED_WITH_ERRORS]: BADGES_COLOR_TYPES.orange,
  [CLAIM_UPLOAD_STATUS.REJECTED]: BADGES_COLOR_TYPES.red,
  [CLAIM_UPLOAD_STATUS.VALIDATION_FAILED]: BADGES_COLOR_TYPES.red,
};

export const getClaimUploadStatusColor = status => STATUS_COLOR[status] || BADGES_COLOR_TYPES.grey;

export const CLAIM_UPLOAD_STATUS_LABEL_KEY = {
  [CLAIM_UPLOAD_STATUS.COMPLETED]: 'statusCompleted',
  [CLAIM_UPLOAD_STATUS.COMPLETED_WITH_ERRORS]: 'statusCompletedWithErrors',
  [CLAIM_UPLOAD_STATUS.REJECTED]: 'statusRejected',
  [CLAIM_UPLOAD_STATUS.VALIDATION_FAILED]: 'statusValidationFailed',
};

export const RESULT_STATE = {
  REJECTED: 'rejected',
  VALIDATE_ONLY: 'validateOnly',
  COMPLETED_WITH_ERRORS: 'completedWithErrors',
  COMPLETED: 'completed',
};

// Order matters: rejection > validate-only (no uploadId) > has-failures > clean.
export const selectResultState = (response, { validateOnly } = {}) => {
  if (!response) return null;
  if (response.structurallyRejected || response.status === CLAIM_UPLOAD_STATUS.REJECTED) {
    return RESULT_STATE.REJECTED;
  }
  if (validateOnly || response.uploadId == null) return RESULT_STATE.VALIDATE_ONLY;
  if (response.failed > 0) return RESULT_STATE.COMPLETED_WITH_ERRORS;
  return RESULT_STATE.COMPLETED;
};

// Offset-based pagination. The backend guide is ambiguous (lists
// `continuationToken` but says it is not returned and to page via total +
// offset). We pass the numeric offset as `continuationToken`. CONFIRM with
// backend at smoke time; if the param name differs, change it only here.
export const buildUploadsParams = ({ pageSize = 25, offset = 0, fromDate, toDate, userUUID }) => {
  const params = { pageSize, continuationToken: String(offset) };
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  if (userUUID) params.userUUID = userUUID;
  return params;
};
